import { render, staticRenderFns } from "./CinemaDetail.vue?vue&type=template&id=3cbe2ef4&scoped=true&"
import script from "./CinemaDetail.vue?vue&type=script&lang=js&"
export * from "./CinemaDetail.vue?vue&type=script&lang=js&"
import style0 from "./CinemaDetail.vue?vue&type=style&index=0&id=3cbe2ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbe2ef4",
  null
  
)

export default component.exports